export default function Price(overlay) {

    this.draw = function(ctx) {

        let layout = overlay.$props.layout
        let candles = layout.candles

        if (candles.length < 2) return

        ctx.strokeStyle = overlay.sett.priceLineColor || '#666666'
        ctx.lineWidth = 1
        ctx.setLineDash([5, 5])
        ctx.beginPath()
        ctx.moveTo(layout.t2screen(candles[0].raw[0]), layout.$2screen(candles[0].raw[4]))
        ctx.lineTo(layout.t2screen(candles[candles.length - 1].raw[0]), layout.$2screen(candles[candles.length - 1].raw[4]))
        ctx.stroke()
        ctx.setLineDash([])
    }
}
